
try {
  process.dlopen(module, __dirname + require("path").sep + __webpack_public_path__ + "7f89dbdfc33cb8f20621ac96fb48ecd0.node");
} catch (error) {
  throw new Error('node-loader:\n' + error);
}
